<template>

  <div>

    <div>

      <div class="buy_card-title">
        <div class="buy_card-title_back">
          <img src="../../../images/NavBar_BG@3x.png"/>
        </div>

        <div class="buy_card-title_text">
          <div class="buy_card-title_text_num">
            {{KCoinInfo.cardCoinNum}}
          </div>
          <div class="buy_card-title_text_desc">
            卡币余额
          </div>
        </div>
      </div>

      <div class="buy_card_content">
        <div class="buy_card_content_title">
          选择数字卡
        </div>

        <div class="card_list_content">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="card_list_content_each boxshadow" :class="[index%2==0?'card_each_margin':'']" v-for="(goods,index) in productList" :key="index" @click="showBuy(goods)">
              <div class="card_list_content_each_image">
                <van-image fit="cover" :src="goods.imageUrl"/>
              </div>
              <div class="card_list_content_bottom">
                <div class="card_list_content_name zt12">
                  {{goods.productName}}
                </div>
                <div class="card_list_content_price">
                  {{goods.price}}<span>元</span>
                  <div class="card_list_content_button">
                    <button>立即购买</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="cart_content" v-if="emptyList">
              <p class="tc grey zt14" style="padding: 2rem 0">暂无可售商品信息</p>
            </div>
            <refresh class="fl full_w" style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: productList.length,show:show}'></refresh>


          </van-pull-refresh>

        </div>

      </div>


    </div>


    <van-overlay :show="showBuyView" @click="showBuyView = false">
      <div class="wrapper" @click.stop>

        <div class="buy_card-spec-goods" >

          <div class="card_detail_spec_title">
            订单确认
          </div>

          <div style="width:20rem;margin: 0 auto;">
            <div class="buy_card-spec-goodsImg">
              <van-image :src="choiceGoods.imageUrl" fit="cover" v-if="choiceGoods.imageUrl">
                <template v-slot:error></template>
              </van-image>
            </div>
            <div class="buy_card-spec-goodsInfo">
              <div class="buy_card-spec-goodsInfo-price">
                {{choiceGoods.productName}}
              </div>
              <div class="buy_card-spec-goodsInfo-stock">
                <!--库存:{{choiceGoods.inventory}}-->
              </div>
              <div class="buy_card-spec-goodsInfo-spec">
                <div style="color:red;text-align: left;display: inline-block;vertical-align: top;">
                  ¥{{choiceGoods.price}}
                </div>
                <div class="card_detail_spec_changeNum">
                  <button class="card_detail_spec_low" @click="lowNum()">-</button>
                  <div class="card_detail_spec_num">{{buyNum}}</div>
                  <button class="card_detail_spec_low" @click="addNum()">+</button>
                </div>
              </div>

            </div>
          </div>

          <div class="buy_card_add_button">
            <button @click="showBuyView = false" class="buy_card_add_button_cancel">取消</button>
            <button @click="addCar" class="buy_card_add_button_sure">确定</button>
          </div>
        </div>

      </div>

    </van-overlay>

  </div>

</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,shareCardUrl,wxUrl } from '@/router/Constant'
  import { getCardList,login,getKCoinInfo,cartInsBuy  } from '@/router/api';
  import { NavBar,Image,Tabbar,DropdownMenu,DropdownItem,SwitchCell,Button } from 'vant';
  import { Search,Overlay,List,PullRefresh,Toast } from 'vant';
  import { setStore,getStore,getCookie,setCookie,GetQueryString,setMiniProgramShare } from '@/utils/mUtil';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: "buyCard",
    data(){
      return {
        productList:[],
        token:getStore('externalLoginKey'),
        productCategoryId:'',
        viewIndex:0,  //default 0
        viewSize:20,
        orderBy:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        show: false,
        allLoaded: false,
        isLoading:false,
        showLoading:true,
        listSize:[],
        emptyList:false,
        KCoinInfo:{},
        buyNum:1,
        choiceGoods:{},
        showBuyView:false
      }
    },

    components: {
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Tabbar.name]: Tabbar,
      [Search.name]: Search,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [SwitchCell.name]: SwitchCell,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh,
    },

    mounted() {
      this.initData()
    },

    methods:{

      async initData() {

        this.getGiftList();
        this.getKCoinInfo()
        setMiniProgramShare('购买卡币数字卡','',wxUrl+encodeURIComponent(shareCardUrl+'buyCard'))
      },


      //判断是否是小程序环境
      // doMiniProgram:function (callback) {
      //   try {
      //     //小程序环境设置分享
      //     var ua = window.navigator.userAgent.toLowerCase();
      //     //判断是否是微信环境
      //     if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //       //微信环境
      //       wx.miniProgram.getEnv(function (res) {
      //         if (res.miniprogram) {
      //           callback();
      //         }
      //       })
      //     }
      //   }
      //   catch (ex) {
      //     console.log(ex);
      //   }
      // },
      //
      // //设置小程序分享
      // setMiniProgramShare:function (shareTitle, imageUrl, shareUrl) {
      //   try {
      //     doMiniProgram(function () {
      //       // 小程序环境下逻辑
      //       wx.miniProgram.postMessage({ data: { title: shareTitle, path: shareUrl, imageUrl: imageUrl } })
      //     });
      //   }
      //   catch (ex) {
      //     console.log(ex);
      //   }
      // },

      //获取K币
      getKCoinInfo:function(){
        getKCoinInfo({externalLoginKey:this.token})
          .then(res => {
            console.log(res);
            console.log("getKCoinInfo")
            if(!res._ERROR_MESSAGE_){
              this.KCoinInfo = res.KCoinMessage
              console.log(this.KCoinInfo)
            }else{
              Toast(res.data._ERROR_MESSAGE_)
            }
          })
          .catch(err => {
            console.log(err);
          });
      },


      //获取电子卡列表
      getGiftList:function () {
        var param = {
          productCategoryId:'DigitCardRoot',
          viewIndex:this.viewIndex,
          viewSize:this.viewSize,
          productStoreId:this.productStoreId,
          prodCatalogId:prodCatalogId
        }
        getCardList(param)
          .then(res => {
            console.log(res);
            console.log("getCardList")
            if (res.productList) {
              if (res.productList.length == 0){
                this.emptyList = true
              } else {
                this.emptyList = false
              }
              this.productList = res.productList;

              this.viewIndex = res.viewIndex;
              this.viewSize = res.viewSize;
              this.listSize = res.listSize;
              if (res.listSize == 0){
                Toast('未搜索到您想要的宝贝')
              }

              setTimeout(() => {
                this.showLoading = false;
              }, 1000);
              if (this.productList.length < res.listSize) {
                this.allLoaded = false
                this.show = true
              }
              console.log(this.productList.length,this.show)

            } else {
              Toast("未搜索到您想要的宝贝");
            }
          })
          .catch(err => {
            console.log(err);
          });

      },

      //下拉刷新
      onRefresh() {
        // if (this.allLoaded != true) {
        setStore('onRefresh',"onRefresh")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // }
      },

      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          this.viewIndex ++;
          var param = {
            productCategoryId:'PhysicalCardRoot',
            viewIndex:this.viewIndex,
            viewSize:this.viewSize,
            productStoreId:this.productStoreId,
            prodCatalogId:prodCatalogId
          }
          getCardList(param)
            .then(res => {
              console.log(res)
              if (res.productList) {
                this.show = true
                if (res.productList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }
                var oldProductList = this.productList
                var newProductList = oldProductList.concat(res.productList)
                this.productList = newProductList
                this.viewIndex = res.viewIndex;
              } else {
                Toast("未搜索到您想要的宝贝");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },


      showBuy:function(goods){
        console.log(2222)
        this.showBuyView = true

        this.choiceGoods = goods

      },

      //用户添加产品数量
      addNum:function () {
        this.buyNum++
        // if(this.buyNum<this.choiceGoods.inventory){
        //
        // }else{
        //   Toast({message:'很遗憾，商品没有库存了'})
        // }
      },

      //用户减少产品数量
      lowNum:function () {
        if(this.buyNum>1){
          this.buyNum--
        }else{
          Toast({message:'已是最小购买量'})
        }
      },


      //用户点击规格确定按钮
      addCar:function () {
        this.cartInsBuy()
        // if(this.buyNum>this.choiceGoods.inventory){
        //   Toast('此商品没有库存了')
        // }else {
        //   this.cartInsBuy()
        // }
      },


      //用户点击立即购买
      cartInsBuy:function(){
        let paramList = {
          externalLoginKey: this.token,
          productId: this.choiceGoods.productId,
          productStoreId: storeName,
          quantity:this.buyNum,
          prodCatalogId:prodCatalogId,
        }
        console.log(paramList)
        cartInsBuy(paramList).then(res => {
          console.log(res)
          console.log('cartInsBuy')
          if(res._ERROR_MESSAGE_){
            Toast({message:res._ERROR_MESSAGE_})
          }else{
            Toast({message:'添加成功'})
            document.querySelector('body').style.overflow = 'scroll'
            this.$router.push({path:'/cardComfirm',query:{type:'dianzi'}})
          }

        }).catch(err =>{
          console.log(err)
        })
      },


    }
  }
</script>

<style>
  .buy_card-title{
    width:100%;
    height: 6.5rem;
  }
  .buy_card-title_back{
    width:100%;
    height: 100%;
  }
  .buy_card-title_back img{
    width:100%;
    height: 100%;
  }
  .buy_card-title_text{
    position: relative;
    top: -4rem;
    width:100%;
    text-align: center;
  }
  .buy_card-title_text_num{
    font-size: 1rem;
    font-weight: bold;
  }
  .buy_card-title_text_desc{
    font-size: 0.8125rem;
  }

  .buy_card_content{
    width:21.875rem;
    margin: 0.625rem auto;
  }
  .buy_card_content_title{
    font-size: 0.875rem;
    font-weight: bold;
    margin-bottom: 0.625rem;
  }

  .card_list_content{
    width:100%;
  }
  .card_list_content_each{
    display: inline-block;
    vertical-align: top;
    width:10.5rem;
    border-radius: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .card_each_margin{
    margin-right: 0.7rem;
  }
  .card_list_content_each_image{
    width:100%;
    height: 9.275rem;
  }
  .card_list_content_each_image .van-image{
    width:100%;
    height: 100%;
    border-top-left-radius: 0.625rem;
    border-top-right-radius: 0.625rem;
  }
  .card_list_content_bottom{
    padding: 0.625rem;
  }
  .card_list_content_name{
    color:#4A4A4A;
    height: 0.625rem;
    line-height: 0.625rem;
  }
  .card_list_content_price{
    font-size: 1rem;
    color:#FF0000;
    height:1.5rem;
    line-height:1.5rem;
    font-weight: bold;
    margin-top: 0.3rem;
  }
  .card_list_content_price span{
    font-size: 0.75rem;
    font-weight: normal;
  }
  .card_list_content_button{
    display: inline-block;
    vertical-align: top;
    width:3.6rem;
    height: 1.5rem;
    float: right;
  }
  .card_list_content_button button{
    width:100%;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 0.875rem;
    border: 1px solid #EB7AA0;
    text-align: center;
    color:#EB7AA0;
    font-size: 0.75rem;
    padding: 0;
  }
  .boxshadow {
    box-shadow: -1px 2px 5px 2px #e0e0e0;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  /*商品规格*/
  .buy_card-spec-goods{
    width:21.4375rem;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    background-color: white;
    border-radius: 0.625rem;
  }
  .buy_card-spec-goodsImg{
    width:6.25rem;
    height: 6.25rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 0.625rem;
  }
  .buy_card-spec-goodsImg .van-image{
    width:100%;
    height: 100%;
  }
  .buy_card-spec-goodsInfo{
    width:calc(100% - 7.25rem);
    display: inline-block;
    vertical-align: top;
  }
  .buy_card-spec-goodsInfo-price{
    font-size:1rem;
    color:#333312;
    margin-bottom: 3rem;
  }
  .buy_card-spec-goodsInfo-stock{
    font-size: 0.875rem;
    color:#666;
    margin-bottom: 0.625rem;
  }
  .buy_card-spec-goodsInfo-spec{
    font-size: 0.875rem;
    color:#666;
  }
  .buy_card-spec-list-each-list div{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .buy_card-spec-list-each-list button{
    display: inline-block;
    vertical-align: top;
    height: 1.5rem;
    line-height: 1.5rem;
    border-radius: 2rem;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
  .buy_card-spec-num button{
    display: inline-block;
    vertical-align: top;
    /*height: 1.5rem;*/
    line-height: 1.5rem;
    border-radius: 0.1rem;
    border: 1px solid #999;
    margin-bottom: 0.625rem;
    margin-right: 0.625rem;
    background-color: white;
    color: #333312;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    text-align: center;
  }
  .buy_card-spec-num div{
    display: inline-block;
    vertical-align: top;
    font-size: 1rem;
    color:#333312;
    margin-right: 0.625rem;
    height: 1.625rem;
    line-height: 1.625rem;
  }
  .buy_card-spec-button button{
    width:18.75rem;
    position: absolute;
    bottom: 0.5rem;
    background-color: #EB7AA0;
    color:white;
    font-size:1rem;
    text-align: center;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 2rem;
  }

  .buy_card_add_button{
    width:20rem;
    text-align: center;
    margin: 1rem auto;
  }
  .buy_card_add_button button{
    width:9rem;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    font-size: 0.875rem;
    border-radius: 2.5rem;
    padding: 0;
  }
  .buy_card_add_button_cancel{
    border:1px solid #EB7AA0;
    color:#EB7AA0;
  }
  .buy_card_add_button_sure{
    background-color:#EB7AA0;
    color:white;
    margin-left: 1.5rem;
  }
  .card_detail_spec_title{
    font-size: 1rem;
    font-weight: bold;
    color:#4a4a4a;
    height: 1.25rem;
    line-height: 1.25rem;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .card_detail_spec_changeNum{
    float: right;
    display: inline-block;
    vertical-align: top;
    background-color: #f2f2f2;
    height: 1.5rem;
    /*width:5rem;*/
  }
  .card_detail_spec_num{
    display: inline-block;
    vertical-align: top;
    background-color: white;
    /*width:1rem;*/
    height: 1.2rem;
    line-height: 1.2rem;
    text-align: center;
    width:1.4rem;
    margin-top: 0.15rem;
  }
  .card_detail_spec_low{
    width:1.6rem;
    height: 1.5rem;
    /*background-color: #ccc;*/
    font-size: 0.75rem;
    color:#636363;
    text-align: center;
    line-height: 1.5rem;
    display: inline-block;
    vertical-align: top;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/cardCurrency/buyCard.vue